import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  title: "",
  description: "These four images correspond to four different sound files. Click the images to listen to them.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 2,
      rows: 2,
      gap: "20px",
      components: [
        [
          {
            variant: "layout",
            data: {
              type: "table",
              options: {
                cols: 1,
                rows: 3,
                rowsSize: [1, 2, 9],
                components: [
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "text",
                          options: {
                            data: "Recording in semi-anechoic room",
                            styles: {
                              textAlign: "left",
                              fontWeight: 700,
                              fontSize: "12px",
                            },
                          },
                        },
                      },
                    },
                  ],
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "text",
                          options: {
                            data:
                              "This recording is made in a semi-anechoic room (small room shown on the previous slide). Only direct sound is present. There are no early or late reflections.",
                          },
                        },
                        styles: {
                          fontSize: "11.6px",
                        },
                      },
                    },
                  ],
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "audioImage",
                          options: {
                            overlayType: "dark",
                            imageSrc: `${config.ASSETS_URL}/05/02/principle/recording-in-semi-anechoic-room.svg`,
                            imageViewType: "fill",
                            audioUrl: `${config.ASSETS_URL}/05/02/principle/recording-in-semi-anechoic-room.wav`,
                            audioGroup: 1,
                          },
                        },
                      },
                    },
                  ],
                ],
              },
            },
          },
          {
            variant: "layout",
            data: {
              type: "table",
              options: {
                cols: 1,
                rows: 3,
                rowsSize: [1, 2, 9],
                components: [
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "text",
                          options: {
                            data: "Direct sound + early + late reflections",
                            styles: {
                              textAlign: "left",
                              fontWeight: 700,
                              fontSize: "12px",
                            },
                          },
                        },
                      },
                    },
                  ],
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "text",
                          options: {
                            data:
                              "This is a processed version of the anechoic recording that simulates the sound in a normal room (large room on the previous slide). All three components of sound are present.",
                          },
                        },
                        styles: {
                          fontSize: "11.6px",
                        },
                      },
                    },
                  ],
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "audioImage",
                          options: {
                            overlayType: "dark",
                            imageSrc: `${config.ASSETS_URL}/05/02/principle/direct sound-early-late-reflections.svg`,
                            imageViewType: "fill",
                            audioUrl: `${config.ASSETS_URL}/05/02/principle/direct sound-early-late-reflections.wav`,
                            audioGroup: 1,
                          },
                        },
                      },
                    },
                  ],
                ],
              },
            },
          },
        ],
        [
          {
            variant: "layout",
            data: {
              type: "table",
              options: {
                cols: 1,
                rows: 3,
                rowsSize: [1, 2, 9],
                components: [
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "text",
                          options: {
                            data: "Direct sound + early reflections",
                            styles: {
                              textAlign: "left",
                              fontWeight: 700,
                              fontSize: "12px",
                            },
                          },
                        },
                      },
                    },
                  ],
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "text",
                          options: {
                            data: "Late reflections are removed, leaving direct sound and early reflections.",
                          },
                        },
                        styles: {
                          fontSize: "11.6px",
                        },
                      },
                    },
                  ],
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "audioImage",
                          options: {
                            overlayType: "dark",
                            imageSrc: `${config.ASSETS_URL}/05/02/principle/direct-sound-early-reflections.svg`,
                            imageViewType: "fill",
                            audioUrl: `${config.ASSETS_URL}/05/02/principle/direct-sound-early-reflections.wav`,
                            audioGroup: 1,
                          },
                        },
                      },
                    },
                  ],
                ],
              },
            },
          },
          {
            variant: "layout",
            data: {
              type: "table",
              options: {
                cols: 1,
                rows: 3,
                rowsSize: [1, 2, 9],
                components: [
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "text",
                          options: {
                            data: "Only late reflections",
                            styles: {
                              textAlign: "left",
                              fontWeight: 700,
                              fontSize: "12px",
                            },
                          },
                        },
                      },
                    },
                  ],
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "text",
                          options: {
                            data:
                              "Direct sound and early reflections are removed, leaving only late reflections (reverberation). Doesn’t it sound as if you’re standing further away?",
                          },
                        },
                        styles: {
                          fontSize: "11.6px",
                        },
                      },
                    },
                  ],
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "audioImage",
                          options: {
                            overlayType: "dark",
                            imageSrc: `${config.ASSETS_URL}/05/02/principle/only-late-reflections.svg`,
                            imageViewType: "fill",
                            audioUrl: `${config.ASSETS_URL}/05/02/principle/only-late-reflections.wav`,
                            audioGroup: 1,
                          },
                        },
                      },
                    },
                  ],
                ],
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
